import "./third-party-library-to-import/tom-select@2.3.1/tom-select.complete.min.js";

document.addEventListener("turbolinks:load", () => {
  // Use event delegation for share icons to work with dynamically loaded content
  $(document).on('click', '.share-icon', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    const observationId = $(this).data('observation-id');
    const observationClipId = $(this).data('observation-clip-id');
    const clubFeedbackObservationId = $(this).data('club-feedback-observation-id');
    const playlistId = $(this).data('playlist-id');
    const videoId = $(this).data('video-id');
    const fixtureId = $(this).data('fixture-id');
    const modal = $('#sharing-modal');
    
    if (modal.length === 0) {
      return false;
    }
    
    // Clear previous data
    modal.removeAttr('data-observation-id data-observation-clip-id data-club-feedback-observation-id data-playlist-id data-video-id data-fixture-id data-observation-type');
    
    if (observationClipId) {
      modal.attr('data-observation-clip-id', observationClipId);
      modal.attr('data-observation-type', 'observation_clip');
    } else if (clubFeedbackObservationId) {
      modal.attr('data-club-feedback-observation-id', clubFeedbackObservationId);
      modal.attr('data-observation-type', 'club_feedback_observation');
    } else if (playlistId) {
      modal.attr('data-playlist-id', playlistId);
      modal.attr('data-observation-type', 'playlist');
    } else if (videoId) {
      modal.attr('data-video-id', videoId);
      modal.attr('data-fixture-id', fixtureId);
      modal.attr('data-observation-type', 'video');
    } else {
      modal.attr('data-observation-id', observationId);
      modal.attr('data-observation-type', 'observation');
    }
    
    modal.modal('show');
    
    return false;
  });

  $(document).on('click', '#sharePlaylistBtn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const playlistId = $(this).data('playlist-id');
    const modal = $('#sharing-modal');
    
    if (modal.length === 0) {
      return false;
    }
    
    // Clear previous data
    modal.removeAttr('data-observation-id data-observation-clip-id data-club-feedback-observation-id data-playlist-id data-video-id data-fixture-id data-observation-type');
    
    modal.attr('data-playlist-id', playlistId);
    modal.attr('data-observation-type', 'playlist');
    modal.modal('show');
    
    return false;
  });

  $(document).on('change', 'input[name="share_type"]', function() {
    const selectedType = $(this).val();
    if (selectedType === 'individuals') {
      $('#users-section').show();
      $('#groups-section').hide();
    } else {
      $('#users-section').hide();
      $('#groups-section').show();
    }
  });

  $('#sharing-modal').on('show.bs.modal', function (event) {
    const modal = $(this);
    const sharingMode = modal.attr('data-sharing-mode');
    const bulkClipIds = modal.attr('data-bulk-clip-ids');
    const bulkVideoIds = modal.attr('data-bulk-video-ids');
    const observationClipId = modal.attr('data-observation-clip-id');
    const clubFeedbackObservationId = modal.attr('data-club-feedback-observation-id');
    const playlistId = modal.attr('data-playlist-id');
    const observationId = modal.attr('data-observation-id');
    const videoId = modal.attr('data-video-id');
    const fixtureId = modal.attr('data-fixture-id');
    
    // Determine observation type based on available data
    let observationType = 'observation';
    if (observationClipId) observationType = 'observation_clip';
    else if (clubFeedbackObservationId) observationType = 'club_feedback_observation';
    else if (playlistId) observationType = 'playlist';
    else if (videoId) observationType = 'video';
    
    const form = modal.find('#sharing-form');
    form[0].reset();
    
    // Clear TomSelect instances before initializing
    clearTomSelectInstances();
    
    if (sharingMode === 'bulk' && bulkClipIds) {
      form.attr('action', '/video_centre/bulk_shared_items');
      form.find('input[name="clip_ids[]"]').remove(); // Remove any existing
      const clipIds = JSON.parse(bulkClipIds);
      clipIds.forEach(function(clipId) {
        form.append(`<input type="hidden" name="clip_ids[]" value="${clipId}">`);
      });
    } else if (sharingMode === 'bulk-videos' && bulkVideoIds) {
      form.attr('action', '/video_centre/bulk_shared_items');
      form.find('input[name="video_ids[]"]').remove(); // Remove any existing
      const videoIds = JSON.parse(bulkVideoIds);
      videoIds.forEach(function(videoId) {
        form.append(`<input type="hidden" name="video_ids[]" value="${videoId}">`);
      });
    } else if (observationType === 'observation_clip') {
      form.attr('action', `/observation_clips/${observationClipId}/shared_items`);
    } else if (observationType === 'club_feedback_observation') {
      form.attr('action', `/club_feedback_observations/${clubFeedbackObservationId}/shared_items`);
    } else if (observationType === 'playlist') {
      form.attr('action', `/video_centre/playlists/${playlistId}/shared_items`);
    } else if (observationType === 'video') {
      form.attr('action', `/fixtures/${fixtureId}/videos/${videoId}/shared_items`);
    } else {
      form.attr('action', `/observations/${observationId}/shared_items`);
    }
    
    // Initialize TomSelect for users
    if (!document.getElementById('shared-users').tomselect) {
      new TomSelect('#shared-users', {
        maxItems: null,
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'name',
        searchField: ['name', 'email'],
        create: false,
        load: function(query, callback) {
          if (!query.length) return callback();
          fetch(`/users/sharing_search?q=${encodeURIComponent(query)}`)
            .then(response => response.json())
            .then(json => callback(json))
            .catch(() => callback());
        },
        onItemAdd: function(value, item) {
          // always clear the search input after adding
          this.setTextboxValue(''); // clear search text
        }
      });
    }
    
    // Initialize TomSelect for levels
    if (!document.getElementById('shared-levels').tomselect) {
      new TomSelect('#shared-levels', {
        maxItems: null,
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'name',
        searchField: ['name'],
        create: false,
        load: function(query, callback) {
          fetch(`/levels/sharing_search_by_customer`)
            .then(response => response.json())
            .then(json => callback(json))
            .catch(() => callback());
        },
        onItemAdd: function(value, item) {
          // always clear the search input after adding
          this.setTextboxValue(''); // clear search text
        }
      });
    }
    
    // Load existing shares for the current item (skip for bulk sharing)
    // Comentado para não pré-carregar compartilhamentos existentes no modal
    // if (sharingMode !== 'bulk' && sharingMode !== 'bulk-videos') {
    //   if (observationType === 'observation_clip') {
    //     loadExistingShares(observationClipId, 'observation_clip');
    //   } else if (observationType === 'club_feedback_observation') {
    //     loadExistingShares(clubFeedbackObservationId, 'club_feedback_observation');
    //   } else if (observationType === 'playlist') {
    //     loadExistingShares(playlistId, 'playlist');
    //   } else if (observationType === 'video') {
    //     loadExistingShares(videoId, 'video');
    //   } else {
    //     loadExistingShares(observationId, 'observation');
    //   }
    // }
  });

  // Add event listener for modal hidden to clean up
  $('#sharing-modal').on('hidden.bs.modal', function (event) {
    // Clear form and TomSelect instances when modal is closed
    const form = $(this).find('#sharing-form');
    form[0].reset();
    clearTomSelectInstances();
    
    // Reset UI state
    $('#share_type_individuals').prop('checked', true);
    $('#users-section').show();
    $('#groups-section').hide();
    
    $(this).removeAttr('data-sharing-mode data-bulk-clip-ids data-bulk-video-ids data-video-id data-fixture-id');
    form.find('input[name="clip_ids[]"]').remove();
    form.find('input[name="video_ids[]"]').remove();
  });

  $(document).on('submit', '#sharing-form', function(e) {
    e.preventDefault();
    
    const form = $(this);
    const formData = new FormData(form[0]);
    
    const csrfToken = $('meta[name="csrf-token"]').attr('content');
    if (csrfToken) {
      formData.append('authenticity_token', csrfToken);
    }
    
    $.ajax({
      url: form.attr('action'),
      method: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      success: function(response) {
        $('#sharing-modal').modal('hide');
        
        showNotification('Item shared successfully!', 'success');
        
        form[0].reset();
        
        clearTomSelectInstances();
        
        $('#share_type_individuals').prop('checked', true);
        $('#users-section').show();
        $('#groups-section').hide();
      },
      error: function(xhr, status, error) {
        showNotification('Failed to share item. Please try again.', 'error');
      }
    });
  });
});

function clearTomSelectInstances() {
  const sharedUsersSelect = document.getElementById('shared-users');
  const sharedLevelsSelect = document.getElementById('shared-levels');
  
  if (sharedUsersSelect && sharedUsersSelect.tomselect) {
    sharedUsersSelect.tomselect.clear();
    sharedUsersSelect.tomselect.clearOptions();
  }
  if (sharedLevelsSelect && sharedLevelsSelect.tomselect) {
    sharedLevelsSelect.tomselect.clear();
    sharedLevelsSelect.tomselect.clearOptions();
  }
}

function loadExistingShares(id, type) {
  let url;
  if (type === 'observation_clip') {
    url = `/observation_clips/${id}/shared_items`;
  } else if (type === 'club_feedback_observation') {
    url = `/club_feedback_observations/${id}/shared_items`;
  } else if (type === 'playlist') {
    url = `/video_centre/playlists/${id}/shared_items`;
  } else if (type === 'video') {
    // For videos, we need fixture_id and video_id
    const modal = document.getElementById('sharing-modal');
    const fixtureId = modal.getAttribute('data-fixture-id');
    url = `/fixtures/${fixtureId}/videos/${id}/shared_items`;
  } else {
    url = `/observations/${id}/shared_items`;
  }
  
  fetch(url, {
    method: 'GET',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(data => {
    const sharedUsersSelect = document.getElementById('shared-users');
    const sharedLevelsSelect = document.getElementById('shared-levels');
    
    // Clear existing options first
    if (sharedUsersSelect && sharedUsersSelect.tomselect) {
      sharedUsersSelect.tomselect.clear();
      sharedUsersSelect.tomselect.clearOptions();
    }
    if (sharedLevelsSelect && sharedLevelsSelect.tomselect) {
      sharedLevelsSelect.tomselect.clear();
      sharedLevelsSelect.tomselect.clearOptions();
    }
    
    if (data.users && data.users.length > 0 && sharedUsersSelect && sharedUsersSelect.tomselect) {
      data.users.forEach(user => {
        sharedUsersSelect.tomselect.addOption({
          id: user.id,
          name: user.name,
          email: user.email
        });
      });
      
      const userIds = data.users.map(user => user.id.toString());
      sharedUsersSelect.tomselect.setValue(userIds);
    }
    
    if (data.levels && data.levels.length > 0 && sharedLevelsSelect && sharedLevelsSelect.tomselect) {
      data.levels.forEach(level => {
        sharedLevelsSelect.tomselect.addOption({
          id: level.id,
          name: level.name
        });
      });
      
      const levelIds = data.levels.map(level => level.id.toString());
      sharedLevelsSelect.tomselect.setValue(levelIds);
      
      $('#share_type_groups').prop('checked', true);
      $('#users-section').hide();
      $('#groups-section').show();
    }
  })
  .catch(error => {
    console.error('Error loading existing shares:', error);
  });
}

function showNotification(message, type) {
  if (typeof window.showAlert === 'function') {
    window.showAlert(message, type);
  } else if (typeof toastr !== 'undefined') {
    toastr[type](message);
  } else {
    alert(message);
  }
}
